import React, { useState, useRef } from 'react';

const FileDropzone = ({ files, setFiles }) => {
    const [dragging, setDragging] = useState(false);
    const fileInputRef = useRef(null);
    const [dirmode, setDirmode] = useState(false);

    const AUDIO_EXTENSIONS = [
        '.wav', '.mp3', '.flac', '.aac', '.ogg', '.m4a', '.zip'
    ];

    const isAudioFile = (file) => {
        const ext = file.name.toLowerCase().slice(file.name.lastIndexOf('.'));
        return file.type.startsWith('audio/') || AUDIO_EXTENSIONS.includes(ext);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        setDragging(true);
    };

    const handleDragEnter = (e) => {
        e.preventDefault();
        setDragging(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        setDragging(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setDragging(false);

        if (e.dataTransfer.items) {
            const items = Array.from(e.dataTransfer.items);
            const fileList = [];

            items.forEach((item) => {
                if (item.kind === 'file') {
                    const file = item.getAsFile();
                    if (file && isAudioFile(file)) {
                        fileList.push(file);
                    }
                }
            });

            setFiles(fileList);   // ← 親state更新
        }
    };

    const handleClick = () => {
        fileInputRef.current?.click();
    };

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            const fileList = Array.from(e.target.files);
            setFiles(fileList);   // ← 親state更新
        }
    };

    const modeChange = () => {
        setDirmode(!dirmode);
    };

    return (
        <div
            className="drop_area"
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            }}
        >
            {dirmode ? (
                <>
                    <div
                        style={{
                            border: dragging ? '2px dashed #00f' : '2px solid #ccc',
                            padding: '30px',
                            width: 'auto',
                            height: '200px',
                            textAlign: 'center',
                            margin: '20px',
                            cursor: 'pointer',
                            backgroundColor: '#ebebebff',
                            overflowY: 'auto',
                            borderRadius: '15px',
                            boxShadow: `
                                -4px -4px 8px rgba(255, 255, 255, 0.9),
                                6px  6px 12px rgba(0, 0, 0, 0.2)
                            `,
                        }}
                        onDragOver={handleDragOver}
                        onDragEnter={handleDragEnter}
                        onDragLeave={handleDragLeave}
                        onDrop={handleDrop}
                        onClick={handleClick}
                    >
                        {files.length > 0 ? (
                            files.map((file, index) => (
                                <div className="in_file_name" key={index}>
                                    {file.webkitRelativePath || file.name}
                                </div>
                            ))
                        ) : (
                            'Click here to select a directory'
                        )}

                        <input
                            type="file"
                            accept="audio/*,.wav,.mp3,.flac,.aac,.ogg,.m4a,.zip"
                            directory=""
                            webkitdirectory=""
                            ref={fileInputRef}
                            style={{ display: 'none' }}
                            onChange={handleFileChange}
                            multiple
                        />
                    </div>
                </>
            ) : (
                <>
                    <div
                        style={{
                            border: dragging ? '2px dashed #00f' : '2px solid #ccc',
                            padding: '30px',
                            width: 'auto',
                            height: '200px',
                            textAlign: 'center',
                            margin: '20px',
                            cursor: 'pointer',
                            backgroundColor: '#ebebebff',
                            overflowY: 'auto',
                            borderRadius: '15px',
                            boxShadow: `
                                -4px -4px 8px rgba(255, 255, 255, 0.9),
                                6px  6px 12px rgba(0, 0, 0, 0.2)
                            `,
                        }}
                        onDragOver={handleDragOver}
                        onDragEnter={handleDragEnter}
                        onDragLeave={handleDragLeave}
                        onDrop={handleDrop}
                        onClick={handleClick}
                    >
                        {files.length > 0 ? (
                            files.map((file, index) => (
                                <div className="in_file_name" key={index}>
                                    {file.webkitRelativePath || file.name}
                                </div>
                            ))
                        ) : (
                            'Drag & drop files here'
                        )}

                        <input
                            type="file"
                            ref={fileInputRef}
                            style={{ display: 'none' }}
                            onChange={handleFileChange}
                            multiple
                        />
                    </div>
                </>
            )}

            <button
                style={{
                    padding: '10px',
                    color: 'white',
                    backgroundColor: '#ff56aa',
                    borderRadius: '50px'
                }}
                onClick={modeChange}
            >
                {dirmode ? 'FileMode' : 'DirMode'}
            </button>
        </div>
    );
};

export default FileDropzone;
